import { Modal, Space, Typography } from 'antd';
import { ButtonProps } from 'antd/lib/button';

import styled, { StyledProp, css } from '@/styled';

interface SeeMoreProps extends StyledProp {
  title: string;
  description: string;
  active: boolean;
  setActive: () => void;
}

const SeeMore = ({ className, title, description, active, setActive }: SeeMoreProps) => {
  const defaultButtonProps: ButtonProps = {
    size: 'large'
  };

  return (
    <Modal
      className={className}
      open={active}
      onOk={setActive}
      centered
      closable={false}
      okText='Fechar'
      okButtonProps={{ ...defaultButtonProps }}
      cancelButtonProps={{ style: { display: 'none' } }}
      maskClosable={false}
      width={600}
      destroyOnClose
    >
      <Space direction='vertical' size={16} className='seemore-data'>
        <Space direction='vertical' size={4}>
          <Typography.Title level={3}>{title}</Typography.Title>
        </Space>
      </Space>
      <div className='seemore-preview-content'>
        <Typography.Text>{description}</Typography.Text>
      </div>
    </Modal>
  );
};

export default styled(SeeMore)`
  ${({ theme }) => css`
    .ant-modal-content {
      background-color: ${theme.colorBgBase};
    }

    h3.ant-typography {
      margin-bottom: 0;
    }

    .seemore-preview-description {
      font-size: ${theme.space.pxToRem(16)};
    }

    .seemore-data {
      margin-bottom: ${theme.space.spacing(4)};
    }

    .seemore-preview-content {
      overflow: auto;
      max-height: 55vh;
      padding: ${theme.space.spacing(4)};
      background-color: ${theme.colorInfoBg};
      border-radius: ${theme.borderRadius}px;
      white-space: pre-line;

      .ant-typography {
        font-size: ${theme.space.pxToRem(16)};
        color: ${theme.colorTextSecondary};
      }
    }

    .ant-modal-footer {
      margin-top: ${theme.space.pxToRem(16)};

      button.ant-btn {
        + button.ant-btn:not(.ant-dropdown-trigger) {
          margin-inline-start: ${theme.space.pxToRem(16)};
        }
      }

      ${theme.breakpoints.down('sm')} {
        display: flex;
        flex-direction: column-reverse;
        gap: ${theme.space.pxToRem(16)};

        button.ant-btn {
          width: 100%;

          + button.ant-btn:not(.ant-dropdown-trigger) {
            margin-inline-start: 0;
          }
        }
      }
    }
  `}
`;
